<template>
  <div class="modal fade show my-2" aria-labelledby="addNewCardTitle" style="display: block; background: #1c1d1c33">
    <div class="modal-dialog modal-md modal-dialog-centered" ref="modalRef">
      <div class="modal-content">
        <div class="row">
          <div class="col-12">
            <div class="d-flex justify-content-between px-1 my-1 align-item-center">
              <h1 class="mb-0">Cleared Cheque - {{ title }} </h1>
              <button
                  @click="onClickClose"
                  type="button"
                  class="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
              ></button>
            </div>
          </div>
        </div>

        <hr class="mt-0 mb-0">

        <div class="pb-2">
          <div class="row mx-2">
            <div class="col-12">
              <label class="form-label">Note <span class="required">*</span></label>
              <input type="text" class="form-control" v-model="formData.note">
            </div>

            <div class="col-12">
              <label class="form-label">Bank Statement Date <span class="required">*</span></label>
              <input type="date" class="form-control" v-model="formData.bank_statement_date" >
            </div>

            <div v-if="! forceCleared" class="col-12 mt-2">
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="isClearedCheck"
                  v-model="formData.is_cleared"
                >
                <label class="form-check-label" for="isClearedCheck">
                  Is Cleared
                </label>
              </div>
              <small class="text-muted">
                When checked: status updates to cleared. Otherwise: status updates to paid.
              </small>
            </div>

            <div class="col-12 text-center mb-2 mt-2">
              <button :disabled="loading" @click="submit" type="button" class="btn btn-primary full-width me-1 waves-effect waves-float waves-light">
                <div v-if="loading" class="spinner-border spinner-border-sm text-light" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Loader v-if="loader"/>

  </div>
</template>

<script setup>
import Loader from "@/components/atom/LoaderComponent";
import {inject, onMounted, ref, watch} from "vue";
import { useStore } from "vuex";
import { useRoute } from 'vue-router';
import handleAccounting from '@/services/modules/accounting'

const formData = ref({
  note:'',
  bank_statement_date:'',
  is_cleared: false,
})

const props = defineProps({
  accountHeadId: null,
  selectedItem: null,
  forceCleared: { type: Boolean, default: false },
})

const emit = defineEmits(['close', 'getData']);
const $store = useStore();
const $route = useRoute();
const modalRef = ref(null);
const loading = ref(false);
const title = ref('');
const isEdit = ref(false);
const loader = ref(false);
const showError = inject('showError');
const showSuccess = inject('showSuccess');

const { updateChequeRegisterStatus, fetchSingleChequeRegister } = handleAccounting();

const submit = async() => {
  const query = getQuery();
  loading.value = true;
  await storeData(query)
}

const storeData = async (query) => {
  const willClear = props.forceCleared || formData.value.is_cleared;
  const confirmMsg = willClear
    ? "Are you sure you want to mark this cheque as cleared?"
    : "Are you sure you want to mark this cheque as paid?";
  const confirmed = confirm(confirmMsg);
  if (!confirmed) return;

  let chequeData = {};
  chequeData.note = formData.value.note;
  chequeData.bank_statement_date = formData.value.bank_statement_date;
  chequeData.account_head_id = props.accountHeadId;
  chequeData.status = willClear ? 'cleared' : 'paid';

  await updateChequeRegisterStatus(chequeData, props.selectedItem.id, query).then((res) => {
    loading.value = false
    if (!res.status) return showError(res.message)
    emit('getData')
    onClickClose();
    showSuccess(res.message)
  }).catch(err => {
    console.log(err)
  }).finally(() => {
    loading.value = false
  })
}

const onClickClose = () => {
  emit('close')
}

function getQuery() {
  return `?company_id=${$route.params.companyId}`;
}

const fetchData = async () => {
    loader.value = true;
    const query = getQuery();
    await fetchSingleChequeRegister(props.selectedItem.id, query).then(res => {
        if (! res.status) {
            return
        }

        title.value = res.data.cheque_number
        if (res.data.note) formData.value.note = res.data.note
        if (res.data.bank_statement_date) formData.value.bank_statement_date = res.data.bank_statement_date
    }).finally(() => {
        loader.value = false;
    });
}

onMounted(() => {
  formData.value.bank_statement_date = new Date().toISOString().split('T')[0];
  if (props.forceCleared) formData.value.is_cleared = true;
  if (props.selectedItem) {
      fetchData();
  }
})

</script>
